import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ExtractService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation list
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getExtractList(configData: any, isTcoins: boolean) {
        let config = this.httpService.setHeaderConfig(true);
        const url = isTcoins ? UrlConnectionEnum.GET_EXTRACT_LIST_TCOINS : UrlConnectionEnum.GET_EXTRACT_LIST_TICKET;
        return await lastValueFrom(this.httpService.get(url, configData, config));
    }

    /**
     * Gets extract total
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getExtractTotal(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_EXTRACT_TOTAL, configData, config));
    }

    /**
     * Gets extract expiring
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getExtractExpiring(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_EXTRACT_EXPIRING, configData, config));
    }
}
